import React, { Component } from 'react'
import { connect } from 'react-redux'
import { login } from '../actions/userActions'
import {Redirect} from 'react-router-dom'

@connect((store)=>{
  return {
    auth: store.user.auth,
    loginProgress: store.user.loginProgress,
    error: store.user.loginError,
  } 
})
class Login extends Component {

  handleSubmit = (e) => {
    e.preventDefault()
    this.props.dispatch(login(this.email.value, this.pw.value))
  }

  render() {

    if(this.props.auth){
      return (<Redirect to='/transactions'/>)
    }
    
    return (
      <div>
          <h6><i className="far fa-user" style={{color:"#33C3F0"}}/> Login</h6>
          {this.props.error?
          <p>Error: {this.props.error.message}</p>:null
          }
          <form onSubmit={this.handleSubmit}>
            <div className="row">
            <input className="six columns login-form" required type="email" ref={(email) => this.email = email} placeholder="Email"/>
            </div>
            <div className="row">
            <input className="six columns login-form" required type="password" placeholder="Password" ref={(pw) => this.pw = pw} />
            </div>
            <button type="submit" className="button-primary">Login</button>
        
        </form>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login.js